var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.budget && _vm.budget.label)?_c('simple-text',{attrs:{"content":_vm.budget.label}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }